import axios from 'axios'
import { apiService, handleApiException, handleResponseData } from '../../../services/api.service'

export interface ExportRequest {
  customerId: number | null
  dateRangeStart: Date
  dateRangeEnd: Date
  language: 'EN' | 'RU'
  statuses: Array<string>
  useCreatedDate: boolean
  profiles: Array<number>
}

export interface ExportRequestV2 extends ExportRequest {
  declarationTypes: Array<string>
}

function postExport({
  customerId,
  dateRangeStart,
  dateRangeEnd,
  language,
  statuses,
  useCreatedDate,
  profiles,
}: ExportRequest) {
  return axios
    .post(
      apiService.getFullApiUrl('/export'),
      {
        customerId,
        dateRangeStart: dateRangeStart.toISOString() ?? null,
        dateRangeEnd: dateRangeEnd.toISOString() ?? null,
        language,
        statuses,
        useCreatedDate,
        profiles,
      },
    )
    .then(handleResponseData)
    .catch(handleApiException)
}

function createExport({
  customerId,
  dateRangeStart,
  dateRangeEnd,
  language,
  statuses,
  useCreatedDate,
  profiles,
  declarationTypes,
}: ExportRequestV2) {
  const baseUrl = process.env.REACT_APP_API_URL
  return axios.post(`${baseUrl}/v2/export`, {
    customerId,
    dateRangeStart: dateRangeStart.toISOString() ?? null,
    dateRangeEnd: dateRangeEnd.toISOString() ?? null,
    language,
    statuses,
    useCreatedDate,
    profiles,
    declarationTypes,
  })
    .then(handleResponseData)
    .catch(handleApiException)
}

const ExportService = {
  postExport,
  createExport,
}

export default ExportService
